import {
    Card,
    CardActionArea,
    CardContent,
    Stack,
    SvgIcon,
    Typography,
} from '@mui/material';
import BookOpenIcon from '@heroicons/react/24/solid/BookOpenIcon';
import ChevronRightIcon from '@heroicons/react/24/solid/ChevronRightIcon';
import { FunctionComponent } from 'react';

interface DocumentationCardProps {
    onOpen: () => void;
}

/** Pressable card that opens the full documentation. */
export const DocumentationCard: FunctionComponent<DocumentationCardProps> = ({
    onOpen,
}) => (
    <Card>
        <CardActionArea onClick={onOpen}>
            <CardContent
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Stack direction='row' spacing={4} alignItems='center'>
                    {/*
                     * Heroicons are raw SVGs that inherit `currentColor` — here
                     * that would be `text.primary`, i.e. near-black, which no
                     * other icon in the app is. Wrapping them in `SvgIcon` with
                     * `color='action'` puts them on the palette's icon colour.
                     */}
                    <SvgIcon color='action' fontSize='small'>
                        <BookOpenIcon />
                    </SvgIcon>
                    <Stack>
                        <Typography variant='h6'>Dokumentation</Typography>
                        <Typography variant='body2' color='text.secondary'>
                            Wie die Widgets eingebunden und angepasst werden.
                        </Typography>
                    </Stack>
                </Stack>
                <SvgIcon color='action' fontSize='small'>
                    <ChevronRightIcon />
                </SvgIcon>
            </CardContent>
        </CardActionArea>
    </Card>
);
